export default [
  {
    path: "/quotes",
    name: "quotes",
    component: () => import("../components/Quotes.vue"),
    meta: {
      title: "QUOTES",
      needsAuth: true,
      verified: true,
      roles: [
        "student",
        "teacher",
        "manager",
        "moderator",
        "admin",
        "superadmin",
      ],
      guest: false,
    },
  },
  {
    path: "/quotes/:id",
    name: "quote",
    component: () => import("../components/Quote.vue"),
    meta: {
      title: "QUOTE",
      needsAuth: true,
      verified: true,
      roles: [
        "student",
        "teacher",
        "manager",
        "moderator",
        "admin",
        "superadmin",
      ],
      guest: false,
    },
  },
];
